var map = {
	"./blockchain/GridtNftDataMapper.js": 198,
	"./blockchain/datasource/ContractAddressDataSource.js": 138,
	"./blockchain/usecase/get_image_for_layer_usecase.js": 725,
	"./blockchain/usecase/get_transaction_data_for_layers_usecase.js": 292,
	"./edit/paste.js": 726,
	"./edit/selection.js": 727,
	"./edit/undo.js": 728,
	"./effects/abstract/css.js": 64,
	"./effects/black_and_white.js": 729,
	"./effects/blueprint.js": 730,
	"./effects/blur.js": 731,
	"./effects/box_blur.js": 732,
	"./effects/brightness.js": 733,
	"./effects/contrast.js": 734,
	"./effects/denoise.js": 735,
	"./effects/dither.js": 736,
	"./effects/dot_screen.js": 737,
	"./effects/edge.js": 738,
	"./effects/emboss.js": 739,
	"./effects/enrich.js": 740,
	"./effects/grains.js": 741,
	"./effects/grayscale.js": 742,
	"./effects/heatmap.js": 743,
	"./effects/hue_rotate.js": 744,
	"./effects/mosaic.js": 745,
	"./effects/negative.js": 746,
	"./effects/night_vision.js": 747,
	"./effects/oil.js": 748,
	"./effects/pencil.js": 749,
	"./effects/saturate.js": 750,
	"./effects/sepia.js": 751,
	"./effects/shadow.js": 752,
	"./effects/sharpen.js": 753,
	"./effects/solarize.js": 754,
	"./effects/tilt_shift.js": 755,
	"./effects/vibrance.js": 756,
	"./effects/vignette.js": 757,
	"./effects/vintage.js": 815,
	"./effects/zoom_blur.js": 758,
	"./file/new.js": 759,
	"./file/open.js": 200,
	"./file/print.js": 760,
	"./file/quickload.js": 761,
	"./file/quicksave.js": 762,
	"./file/save.js": 291,
	"./file/search.js": 287,
	"./help/about.js": 764,
	"./help/shortcuts.js": 765,
	"./help/translate.js": 153,
	"./image/auto_adjust.js": 766,
	"./image/color_corrections.js": 767,
	"./image/convert_to_256_colors.js": 288,
	"./image/decrease_colors.js": 768,
	"./image/flip.js": 769,
	"./image/grid.js": 770,
	"./image/histogram.js": 771,
	"./image/information.js": 772,
	"./image/opacity.js": 773,
	"./image/palette.js": 816,
	"./image/resize.js": 774,
	"./image/rotate.js": 775,
	"./image/size.js": 776,
	"./image/translate.js": 777,
	"./image/trim.js": 154,
	"./image/zoom.js": 778,
	"./layer/clear.js": 779,
	"./layer/composition.js": 780,
	"./layer/delete.js": 781,
	"./layer/differences.js": 782,
	"./layer/duplicate.js": 783,
	"./layer/flatten.js": 784,
	"./layer/merge.js": 785,
	"./layer/move.js": 786,
	"./layer/new.js": 787,
	"./layer/raster.js": 155,
	"./layer/rename.js": 290,
	"./layer/visibility.js": 788,
	"./tools/borders.js": 789,
	"./tools/color_to_alpha.js": 790,
	"./tools/color_zoom.js": 791,
	"./tools/content_fill.js": 792,
	"./tools/grid.js": 793,
	"./tools/keypoints.js": 794,
	"./tools/replace_color.js": 795,
	"./tools/restore_alpha.js": 796,
	"./tools/settings.js": 797,
	"./tools/sprites.js": 798
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 724;